import styled from "@emotion/styled";
import { media } from "../../components/Window/themes";
const Avatar = {
    Image: styled.img `
    border-radius: 50%;
    min-height: 2.5rem;
    min-width: 2.5rem;
    height: 0;
    width: 0;
    ${media.medium} {
      min-height: 2rem;
      min-width: 2rem;
    }
  `,
    Initials: styled.div `
    border-radius: 50%;
    min-height: 2.5rem;
    min-width: 2.5rem;
    height: 0;
    width: 0;
    text-align: center;
    line-height: 2.5em;
    background-color: ${(props) => props.color};
    font-weight: bold;
    color: white;
  `,
};
export default Avatar;
//# sourceMappingURL=Avatar.styled.js.map